// @flow
import type { Action, Address } from './types';
import {
	SAVE_DELIVERY_ADD,
	SAVE_DELIVERY_ADD_SUCCESS,
	SAVE_DELIVERY_ADD_ERROR,
	FETCH_DELIVERY_ADD,
	FETCH_DELIVERY_ADD_SUCCESS,
	FETCH_DELIVERY_ADD_ERROR,
	SET_DELIVERY_ADD,
} from './types';

export const saveDeliveryAddress = (address: Address, imei: string, mobile: string, index: number): Action => ({
	type: SAVE_DELIVERY_ADD,
	payload: {
		address,
		imei,
		mobile,
		index,
	},
});

export const saveDeliveryAddressSuccess = (address: Array<Address>): Action => ({
	type: SAVE_DELIVERY_ADD_SUCCESS,
	payload: address,
});

export const saveDeliveryAddressError = (error: Error): Action => ({
	type: SAVE_DELIVERY_ADD_ERROR,
	payload: error,
});

export const fetchDeliveryAddress = (mobile: string, imei?: string): Action => ({
	type: FETCH_DELIVERY_ADD,
	payload: {
		mobile,
		imei,
	},
});

export const fetchDeliveryAddressSuccess = (data: Array<any> = []): Action => ({
	type: FETCH_DELIVERY_ADD_SUCCESS,
	payload: data,
});

export const fetchDeliveryAddressError = (error: Error): Action => ({
	type: FETCH_DELIVERY_ADD_ERROR,
	payload: error,
});

export const setDeliveryAddress = (address:? Address): Action => ({
	type: SET_DELIVERY_ADD,
	payload: address,
});